import { postJson } from '../ap/utils/fetchService';
import { config } from '../config/config';

type PayResponse = {
  status: string;
  errorMessage: string;
  cost: number;
  referenceId: string;
  orderFiles: any;
}

type Token = {
  token: string;
}

export function pay(args: { orderId: string, token: string, customerId: string }) {

  let url = config.ordersConfig.ordersEndpoint + "/" + args.orderId + "/pay";
  let body = { token : args.token, customerId: args.customerId};

  return postJson<PayResponse>({
    url: url,
    body: body
  });
}
